/* compoCASE – Produktgalerie nach Farbe (nur Handyhüllen, Vorlage product.json)
   Gewählte Farbe: zuerst die Produktbilder dieser Farbe, danach die 6 gemeinsamen Bilder.
   Bilder anderer Farben und die alten allgemeinen Bilder werden ausgeblendet. */
(function () {
  var SHARED = ['01-compocase-handyhuelle', '03-compocase-handyhuelle', '02-compocase-handyhuelle',
                '06-compocase-handyhuelle', '04-compocase-handyhuelle', '05-compocase-handyhuelle'];
  var LEGACY = /(iPhone16_lifestyle|iPhone_case_mit_wirless_charging|iPhone_H_lle_aus_Weizenstroh_mit_Kameraschutz|iPhone_mit_sichtbarer_Materialstruktur|iPhone_mit_angenehmer_Haptik)/;
  var COLORS = ['Midnight Black', 'Arctic Blue', 'Forest Green', 'Soft Rose', 'Stone White'];
  var lastColor = null;

  function gallery() {
    return document.querySelector('media-gallery[id^="MediaGallery-template"]');
  }

  function currentColor() {
    var r = document.querySelector('variant-selects input[type="radio"][name^="Farbe"]:checked');
    if (r) return r.value;
    var s = document.querySelector('variant-selects select[name^="Farbe"]');
    if (s) return s.value;
    var j = document.querySelector('variant-selects [data-selected-variant]');
    if (j) {
      try {
        var t = (JSON.parse(j.textContent) || {}).title || '';
        for (var i = 0; i < COLORS.length; i++) if (t.indexOf(COLORS[i]) > -1) return COLORS[i];
      } catch (e) {}
    }
    return null;
  }

  function classify(li) {
    var img = li.querySelector('img');
    if (!img) return { type: 'any' };
    var src = img.getAttribute('src') || '';
    for (var i = 0; i < SHARED.length; i++) if (src.indexOf(SHARED[i]) > -1) return { type: 'shared', index: i };
    if (LEGACY.test(src)) return { type: 'legacy' };
    var alt = img.getAttribute('alt') || '';
    for (var c = 0; c < COLORS.length; c++) if (alt.indexOf(COLORS[c]) > -1) return { type: 'color', color: COLORS[c] };
    return { type: 'any' };
  }

  function apply(force) {
    var g = gallery();
    if (!g) return;
    var main = g.querySelector('[id^="Slider-Gallery"]');
    if (!main) return;
    var items = Array.prototype.slice.call(main.querySelectorAll(':scope > li[data-media-id]'));
    var info = items.map(classify);
    if (!info.some(function (k) { return k.type === 'shared'; })) return;

    var color = currentColor();
    var own = [], shared = [], hidden = [];
    items.forEach(function (li, i) {
      var k = info[i];
      if (k.type === 'shared') shared[k.index] = li;
      else if (k.type === 'legacy') hidden.push(li);
      else if (k.type === 'color' && color && k.color !== color) hidden.push(li);
      else own.push(li);
    });
    var visible = own.concat(shared.filter(Boolean));

    visible.forEach(function (li) { li.classList.remove('cc-hide'); main.appendChild(li); });
    hidden.forEach(function (li) { li.classList.add('cc-hide'); main.appendChild(li); });

    var thumbs = g.querySelector('[id^="Slider-Thumbnails"]');
    if (thumbs) {
      var pos = 0;
      visible.forEach(function (li) {
        var t = thumbs.querySelector('[data-target="' + li.dataset.mediaId + '"]');
        if (!t) return;
        t.classList.remove('cc-hide');
        t.dataset.mediaPosition = ++pos;
        thumbs.appendChild(t);
      });
      hidden.forEach(function (li) {
        var t = thumbs.querySelector('[data-target="' + li.dataset.mediaId + '"]');
        if (!t) return;
        t.classList.add('cc-hide');
        thumbs.appendChild(t);
      });
    }

    var hiddenIds = {};
    hidden.forEach(function (li) { hiddenIds[li.dataset.mediaId.split('-').pop()] = true; });
    document.querySelectorAll('.product-media-modal__content [data-media-id]').forEach(function (el) {
      var id = String(el.dataset.mediaId).split('-').pop();
      el.classList.toggle('cc-hide', !!hiddenIds[id]);
    });

    var active = main.querySelector('li.is-active');
    var colorChanged = color !== lastColor;
    lastColor = color;
    if (visible.length && (force || colorChanged || !active || active.classList.contains('cc-hide'))) {
      if (!force && colorChanged && typeof g.setActiveMedia === 'function') {
        g.setActiveMedia(visible[0].dataset.mediaId, false);
      } else {
        items.forEach(function (li) { li.classList.remove('is-active'); });
        visible[0].classList.add('is-active');
        main.scrollLeft = 0;
        if (thumbs) {
          var t0 = thumbs.querySelector('[data-target="' + visible[0].dataset.mediaId + '"] button');
          thumbs.querySelectorAll('button').forEach(function (b) { b.removeAttribute('aria-current'); });
          if (t0) t0.setAttribute('aria-current', 'true');
          thumbs.scrollLeft = 0;
        }
      }
    }

    [main.closest('slider-component'), thumbs && thumbs.closest('slider-component')].forEach(function (s) {
      if (s && typeof s.resetPages === 'function') { try { s.resetPages(); } catch (e) {} }
    });
  }

  function init() {
    apply(true);
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { apply(false); }, 0); });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) {
        setTimeout(function () { apply(false); }, 700);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
